# Following Vue component standards from rule 2000-vue-component
<template>
  <div>
    <v-card flat>
      <v-card-title class="text-h5 font-weight-bold">
        {{ $t('Terms & Conditions') }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-card outlined class="mb-4">
                <v-card-text class="d-flex align-center">
                  <div class="text-subtitle-1 font-weight-medium">
                    {{ $t('Page Status') }}
                  </div>
                  <v-spacer></v-spacer>
                  <v-switch
                    v-model="formData.pages.terms.active"
                    :label="
                      formData.pages.terms.active
                        ? $t('Active')
                        : $t('Inactive')
                    "
                    dense
                    hide-details
                    class="mt-0"
                    @change="updateForm"
                  ></v-switch>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card outlined class="pa-4">
                <v-card-title class="text-subtitle-1 px-0 pt-0">
                  {{ $t('Terms & Conditions Content') }}
                </v-card-title>

                <text-editor
                  v-model="formData.pages.terms.content"
                  :show-save-button="false"
                  :autofocus="true"
                  @input="updateForm"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FormRulesMixin from 'components/mixins/form-rules-mixin'
import TextEditor from 'components/common/text-editor'

export default {
  name: 'TermsPage',

  components: {
    TextEditor,
  },

  mixins: [FormRulesMixin],

  props: {
    bookingEngineSetting: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        name: this.bookingEngineSetting.name,
        pages: {
          terms: {
            active: this.bookingEngineSetting.pages?.terms?.active || false,
            content: this.bookingEngineSetting.pages?.terms?.content || '',
          },
        },
      },
    }
  },

  watch: {
    'formData.pages.terms.active': {
      handler(newVal) {
        this.updateForm()
      },
    },
    bookingEngineSetting: {
      handler(newVal) {
        this.formData = {
          name: newVal.name,
          pages: {
            terms: {
              active: newVal.pages?.terms?.active || false,
              content: newVal.pages?.terms?.content || '',
            },
          },
        }
      },
      deep: true,
    },
  },

  methods: {
    updateForm() {
      if (!this.$refs.form || this.$refs.form.validate()) {
        const updatedData = {
          ...this.bookingEngineSetting,
          pages: {
            ...this.bookingEngineSetting.pages,
            terms: {
              ...this.bookingEngineSetting.pages?.terms,
              ...this.formData.pages.terms,
            },
          },
        }
        this.$emit('update:setting', updatedData)
      }
    },
  },
}
</script>
